import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { DataServiceService } from "../data-service.service";
import { Company } from "../model/Company";

@Component({
  selector: "app-edit-company",
  templateUrl: "./edit-company.component.html",
  styleUrls: ["./edit-company.component.scss"],
})
export class EditCompanyComponent implements OnInit {
  companyData: Company;
  isLoading: boolean = true;
  companyId: string = "";
  newRemarks: string = "";
  newStatus: string = "";
  companyStatusList: string[] = [
    "Inforce",
    "Renewal Grace Period",
    "Suspended",
    "Expired",
    "Cancelled",
  ];

  constructor(
    private modalService: NgbModal,
    private dataService: DataServiceService,
    private route: ActivatedRoute
  ) {
    this.companyId = this.route.snapshot.params.companyId
      ? this.route.snapshot.params.companyId
      : "";
  }

  ngOnInit(): void {
    this.getCompanyData().then(() => {
      this.newStatus = this.companyData.status;
      this.isLoading = false;
    });
  }

  openSmallModal(smallModalContent) {
    this.modalService.open(smallModalContent, { size: "sm" });
  }

  updateCompany() {
    this.dataService
      .updateCompany(this.companyId, this.companyData)
      .then(() => {
        const but = document.getElementById("successBtn") as HTMLButtonElement;
        but.click();
      })
      .catch(() => {
        const but = document.getElementById("failBtn") as HTMLButtonElement;
        but.click();
      });
  }

  async getCompanyData() {
    this.companyData = await this.dataService.getCompanyById(this.companyId);
  }

  invalidType() {
    if (this.companyData.companyType.trim() == "") return true;
    else return false;
  }

  invalidAddress() {
    if (this.companyData.registeredAddress.trim() == "") return true;
    else return false;
  }

  invalidForm() {
    return this.invalidType() || this.invalidAddress();
  }

  openSuccessPopup(smallModalContent) {
    this.modalService.open(smallModalContent, { size: "sm" });
  }

  openFailPopup(smallModalContent2) {
    this.modalService.open(smallModalContent2, { size: "sm" });
  }

  changeCompanyStatus(statusModalContent) {
    this.modalService.open(statusModalContent, { size: "md" });
  }

  selectStatus(status) {
    this.newStatus = status;
  }

  updateCompanyStatus() {
    this.dataService
      .updateCompanyStatus(this.companyId, {
        status: this.newStatus,
        statusRemarks: this.newRemarks,
      })
      .then(() => {
        const but = document.getElementById("successBtn") as HTMLButtonElement;
        but.click();
        this.getCompanyData();
      })
      .catch(() => {
        const but = document.getElementById("failBtn") as HTMLButtonElement;
        but.click();
      });
  }

  invalidStatusUpdateForm() {
    if (
      this.companyData.status == this.newStatus &&
      this.companyData.statusRemarks == this.newRemarks
    )
      return true;
    else return false;
  }
}
